import { render } from "./OneAppSolution.vue?vue&type=template&id=f819320e&scoped=true"
import script from "./OneAppSolution.vue?vue&type=script&lang=js"
export * from "./OneAppSolution.vue?vue&type=script&lang=js"

import "./OneAppSolution.vue?vue&type=style&index=0&id=f819320e&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f819320e"]])

export default __exports__